import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Controller } from 'react-hook-form';

const CheckboxInput = (props) => {
    const { value, onChange, control, name, label, rules, disabled } = props;
	return (
        <FormControlLabel
            disabled={disabled}
            control={
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field }) => (
                        <Checkbox
                            {...field}
                            disabled={disabled}
                            color="primary"
                            checked={value}
                            onChange={onChange}
                        />
                    )}
                />
            }
            label={label}
        />
	);
}

CheckboxInput.propTypes = {
    control: PropTypes.object,
    name: PropTypes.string,
    label: PropTypes.string,
    rules: PropTypes.object,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}

export default CheckboxInput;
